import { BasicComponentType } from "@/types/property-panel.types";
import { useDraggable } from "@dnd-kit/core";

interface DraggableProps {
  component: BasicComponentType;
}

function DraggableComponent({ component }: DraggableProps) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: `drag-${component.componentType}`,
    data: { elementType: component.componentType },
  });

  const Icon = component.icon;

  return (
    <button
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className="flex flex-col items-center justify-center gap-1.5 h-[72px] bg-muted/50 rounded-md border border-border text-foreground hover:bg-accent hover:border-primary/50 transition-all text-xs cursor-grab active:cursor-grabbing"
      title={`Drag to add ${component.name} or click to place`}
    >
      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 pointer-events-none">
        <Icon className="w-4 h-4 text-primary pointer-events-none" />
      </div>
      <span className="text-[11px] font-medium text-muted-foreground pointer-events-none">
        {component.name}
      </span>
    </button>
  );
}

export default DraggableComponent;
